var map = {
	"./apiParamsInitialization.js": 9167,
	"./gameParameters.js": 4560,
	"./httpResponse.js": 7682,
	"./messageHelper.js": 5667,
	"./notificationType.js": 6515,
	"./notificationsName.js": 8180,
	"./resources.js": 8513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4940;